import type { Reducer } from 'redux';
import { combineReducers } from 'redux';
import usersDashboardReducer from 'redux/modules/users-page/users-dashboard/usersDashboard.reducer';
import usersListReducer from 'redux/modules/users-page/users-list/usersList.reducer';
import {
  dismissModalUnoccupiedSeatsModal,
  showUnoccupiedSeatsModal,
} from 'redux/modules/users-page/usersPage.actions';
import type { State as UsersPageState } from 'redux/modules/users-page/usersPage.types';
import { reducerWithInitialState } from 'typescript-fsa-reducers';

const usersUnoccupiedSeatsWarningModalReducer = reducerWithInitialState(false)
  .caseWithAction(showUnoccupiedSeatsModal, () => true)
  .caseWithAction(dismissModalUnoccupiedSeatsModal, () => false);

const usersPageReducer: Reducer<UsersPageState> = combineReducers({
  list: usersListReducer,
  dashboard: usersDashboardReducer,
  showUnoccupiedSeatsWarningModal: usersUnoccupiedSeatsWarningModalReducer,
});

export default usersPageReducer;
